<template>
  <v-container id="noticias" tag="section">
    <base-v-component :heading="title" />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper-variant"
      inline
      class="px-5 py-3"
    >
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="noticia.titulo"
                label="Título"
                ref="titulo"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox v-model="noticia.slider" label="Slider" />
            </v-col>
            <v-col cols="12" md="2" v-if="noticia.slider">
              <v-checkbox
                v-model="noticia.sliderOcultarTitulo"
                label="Ocultar título"
              />
            </v-col>
          </v-row>
          <v-row style="min-height: 300px">
            <v-col cols="12">
              <quill-editor
                :content="noticia.contenido"
                style="height: 200px"
                :options="editorOption"
                @change="onEditorChange($event)"
              ></quill-editor>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row dense no-gutters>
                <v-col cols="2">
                  <input-subir-imagen
                    :soloBoton="true"
                    @imagen-subida="imagenSubida"
                    imgHeight="450"
                    nombre=""
                    :childStorage="
                      'negocios/' + $store.state.app.negocioGest + '/noticias/'
                    "
                /></v-col>
              </v-row>
              <v-row align="center" justify="start">
                <draggable v-model="noticia.imagenes" style="display: flex">
                  <v-card
                    max-width="300px"
                    :key="i"
                    v-for="(img, i) in noticia.imagenes"
                  >
                    <v-img
                      :key="i"
                      class="mx-2"
                      max-width="150"
                      height="150"
                      :src="img.imagenUrl"
                    />

                    <v-card-text>
                      <v-col cols="12">
                        <v-text-field v-model="img.nombre" label="nombre"
                      /></v-col>
                      <v-col cols="12">
                        <v-text-field v-model="img.enlace" label="Enlace"
                      /></v-col>
                      <v-col cols="10" class="">
                        <v-btn class="red" @click="borrarArrayImagen(i)"
                          >Borrar</v-btn
                        >
                      </v-col>
                    </v-card-text>
                  </v-card>
                </draggable>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          :disabled="!saveBtnDisabled"
          @click="save"
          :loading="loadingForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>
            
            <script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import firebase from "firebase";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
import InputSubirImagen from "@/components/admin/InputSubirImagen.vue";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,

    quillEditor,
    InputSubirImagen,
  },
  mixins: [validationMixin],
  validations: {
    noticia: {},
  },
  data() {
    return {
      imagenAux: null, //para subir imágenes
      loadingImagenAux: false,
      loadingForm: false,
      noticia: {
        id: null,
        titulo: "",
        contenido: "",
        imagenes: [],
        slider: false,
      },
      editorOption: {
        placeholder: "Escribe aquí...",
        readOnly: false,
        theme: "snow",
        // modules: {
        //     toolbar: [
        //         ['bold', 'italic', 'underline', 'strike'],
        //         ['blockquote'],
        //         [{ 'header': 1 }, { 'header': 2 }],
        //         [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        //         [{ 'script': 'sub'}, { 'script': 'super' }],
        //         [{ 'indent': '-1'}, { 'indent': '+1' }],
        //         [{ 'direction': 'rtl' }],
        //         [{ 'size': ['small', false, 'large', 'huge'] }],
        //         [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        //         [{ 'color': [] }, { 'background': [] }],
        //         [{ 'font': [] }],
        //         [{ 'align': [] }],
        //         ['clean']
        //       ]
        // },
      },
    };
  },
  computed: {
    saveBtnDisabled() {
      return true;
    },
    title() {
      return this.isEdit
        ? "Editar Noticia " + this.noticia.titulo
        : "Nueva Noticia";
    },
    isEdit() {
      return this.noticia.id != null;
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      role: "auth/role",
    }),
  },
  methods: {
    imagenSubida(e) {
      if (Array.isArray(this.noticia.imagenes)) {
        this.noticia.imagenes.push({
          imagenUrl: e,
          nombre: "",
          enlace: "",
        });
      } else {
        this.noticia.imagenes = [
          {
            imagenUrl: e,
            nombre: "",
            enlace: "",
          },
        ];
      }
    },
    onEditorChange(event) {
      this.noticia.contenido = event.html;
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        _vm.loadingForm = true;
        this.$store
          .dispatch("noticias/saveNoticia", this.noticia)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Noticia añadida con éxito",
            });
            var str;
            switch (this.role) {
              case "boss_negocio":
                str = "/admin/negocio/noticias/";
                break;
              case "admin":
                str = "/admin/gest/" + this.negocio.id + "/noticias/";
                break;
            }
            this.$router.push(str);
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al guardar la noticia: " + error,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
          });
      }
    },
    borrarArrayImagen(i) {
      if (i > -1) {
        this.noticia.arrayImagenes.splice(i, 1);
      }
    },
  },

  async mounted() {
    this.noticia.id = this.$route.params.id_noticia
      ? this.$route.params.id_noticia
      : null;
    if (this.noticia.id) {
      let not = await this.$store.dispatch(
        "noticias/getNoticia",
        this.noticia.id
      );
      this.noticia = not;
    }
  },
};
</script>
            
            <style>
</style>